<template>
  <div>
    <BatchTable
      :orderInspectionDocCode="orderInspectionDocCode"
      :changeOrderCode="changeOrderCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      isExpand
    />
  </div>
</template>
<script>
import BatchTable from './components/order-batch'
export default {
  components: { BatchTable },
  props: {
    orderInspectionDocCode: String,
    changeOrderCode: String,
    disabled: { type: Boolean, default: false },
  },
}
</script>
